module.exports = {
    en: {
        menu: {
            home: 'Home',
            catalog: 'Catalog',
            services: 'Services',
            news: 'News',
            salesteam: "Sales team",
            customcl: "Get Customs clearance",
            vin: "VIN:search",
            send: "Send request"
        }

    },
    ka: {
        menu: {
            home: 'მთავარი',
            catalog: 'კატალოგები',
            services: 'სერვისები',
            news: 'სიახლეები',
            salesteam: "გაყიდვების გუნდი",
            customcl: "განბაჟება",
            vin: "VIN:ძებნა",
            send: "მოთხოვნის გაგზავნა"
        }
    },
    ru: {
        menu: {
            home: 'основной',
            catalog: 'каталог',
            services: 'услуги',
            news: 'новости',
            salesteam: "отдел продаж",
            customcl: "таможенное оформление",
            vin: "VIN:Поиск",
            send: "Отправить запрос"
        }
    }
}